import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireOnboarded = false, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="max-w-7xl mx-auto px-6 py-24 font-mono text-sm text-gray-500">Cargando…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}
